export default "__VITE_ASSET__4KPomN36__"